document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('.seasons-cards .card');
    const products = document.querySelectorAll('.products_wrapper .product');

    function closeCardDetails(card) {
        card.querySelectorAll('details[open]').forEach(d => d.open = false);
    }

    function activateSeason(group) {
        cards.forEach(c => {
            const isActive = c.dataset.group === group;
            c.classList.toggle('active', isActive);
            if (!isActive) {
                closeCardDetails(c);
            }
        });
        products.forEach(p => p.classList.toggle('active', p.dataset.group === group));
    }

    if (cards.length) {
        activateSeason(cards[0].dataset.group);
    }

    const seasonsSwiper = new Swiper('.swiper.seasons-cards', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 23,
        centeredSlides: false,
        watchSlidesProgress: true,
        pagination: {
            el: '.pagination-seasons',
            clickable: true,
        },
        navigation: {
            nextEl: '.nav-next-seasons',
            prevEl: '.nav-prev-seasons',
        },
        breakpoints: {
            0: { slidesPerView: 1 },
            650: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
            1650: { slidesPerView: 4 },
        },
        on: {
            slideChange: function () {
                const activeSlide = this.slides[this.activeIndex];
                if (activeSlide && activeSlide.dataset.group) {
                    activateSeason(activeSlide.dataset.group);
                }
            },
        },
    });

    cards.forEach((card, index) => {
        card.addEventListener('click', function () {
            seasonsSwiper.slideTo(index);
            activateSeason(card.dataset.group);
        });
    });


    // Active card = white
    cards[0].classList.add('active');

    cards.forEach(card => {
        card.addEventListener('click', function (e) {
            cards.forEach(c => c.classList.remove('active'));
            card.classList.add('active');
            activateSeason(card.dataset.group);
        });
    });

    // Details (Faq-cards close on open)
    /*const details = document.querySelectorAll('.faq-box details');

    details.forEach((detail) => {
        detail.addEventListener('toggle', () => {
            if (!detail.open) return;

            details.forEach((other) => {
                if (other !== detail) {
                    other.open = false;
                }
            });
        });
    });*/

    // Details (Seasons-cards close on open)
    const product_details = document.querySelectorAll('.seasons-cards details');

    product_details.forEach((detail) => {
        detail.addEventListener('toggle', () => {
            if (!detail.open) return;

            product_details.forEach((other) => {
                if (other !== detail) {
                    other.open = false;
                }
            });
        });
    });


    // Switch
    products.forEach(function (product) {
        const checkbox = product.querySelector('.switch input[type="checkbox"]');
        const damenView = product.querySelector('.products-damen');
        const herrenView = product.querySelector('.products-herren');

        if (!checkbox || !damenView || !herrenView) return;

        function updateView() {
            if (checkbox.checked) {
                damenView.style.display = 'none';
                herrenView.style.display = '';
            } else {
                damenView.style.display = '';
                herrenView.style.display = 'none';
            }
        }

        // Initialer Zustand beim Laden
        updateView();

        // Bei Wechsel des Switches
        checkbox.addEventListener('change', updateView);
    });
});